import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { Header } from "./components/Header";
import { CartDrawer } from "./components/CartDrawer";
import { Footer } from "./components/Footer";
import { SmoothScroll } from "./components/SmoothScroll";
import { WhatsAppFab } from "./components/WhatsAppFab";
import Home from "./pages/Home";
import ProductPage from "./pages/ProductPage";
import Checkout from "./pages/Checkout";
import OrderPage from "./pages/OrderPage";

function App() {
  return (
    <div className="grain min-h-screen bg-[#0A0A0B]">
      <BrowserRouter>
        <CartProvider>
          <SmoothScroll />
          <Header />
          <CartDrawer />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/product/:slug" element={<ProductPage />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order/:id" element={<OrderPage />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppFab />
          <Toaster theme="dark" position="bottom-left" toastOptions={{ style: { borderRadius: 0, fontFamily: "JetBrains Mono, monospace" } }} />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
